import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Halecor - Μουσική Σχολή</title>
        <meta name="description" content="Halecor - Μουσική Σχολή - Ανακαλύψτε τον κόσμο της μουσικής με επαγγελματικούς εκπαιδευτές και σύγχρονες μεθόδους διδασκαλίας" />
      </Helmet>

      <div style={{ padding: '40px 20px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: '#003366', textAlign: 'center', marginBottom: '30px' }}>Όροι και Προϋποθέσεις Χρήσης</h1>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>1. Αποδοχή Όρων</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Με την πρόσβαση και χρήση της ιστοσελίδας halecor.com και των υπηρεσιών της Halecor Μουσικής Σχολής, 
          αποδέχεστε και συμφωνείτε να δεσμεύεστε από τους παρόντες όρους και προϋποθέσεις. Εάν δεν συμφωνείτε 
          με οποιονδήποτε από αυτούς τους όρους, παρακαλούμε μην χρησιμοποιείτε την ιστοσελίδα μας ή τις υπηρεσίες μας.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>2. Περιγραφή Υπηρεσιών</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Η Halecor προσφέρει μουσικές υπηρεσίες εκπαίδευσης που περιλαμβάνουν:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Ιδιαίτερα μαθήματα μουσικής (πιάνο, κιθάρα, βιολί, τραγούδι κ.ά.)</li>
          <li>Ομαδικά μαθήματα και workshops</li>
          <li>Μουσική θεωρία και αρμονία</li>
          <li>Προετοιμασία για εξετάσεις και διαγωνισμούς</li>
          <li>Online μαθήματα μέσω βιντεοκλήσης</li>
          <li>Ενοικίαση μουσικών αιθουσών για πρόβες</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>3. Εγγραφή και Λογαριασμός</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Για την εγγραφή σε μαθήματα πρέπει να παράσχετε ακριβείς και πλήρεις πληροφορίες. 
          Είστε υπεύθυνοι για τη διατήρηση της εμπιστευτικότητας του λογαριασμού σας και για όλες 
          τις δραστηριότητες που πραγματοποιούνται υπό τον λογαριασμό σας. Θα πρέπει να μας 
          ενημερώσετε αμέσως για οποιαδήποτε μη εξουσιοδοτημένη χρήση του λογαριασμού σας.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>4. Πληρωμές και Τιμές</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Όλες οι τιμές εμφανίζονται σε ευρώ (€) και περιλαμβάνουν ΦΠΑ όπου ισχύει. Οι τιμές μπορεί 
          να αλλάξουν χωρίς προειδοποίηση, αλλά οι αλλαγές δεν θα επηρεάσουν ήδη επιβεβαιωμένες κρατήσεις.
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Η πληρωμή πραγματοποιείται προκαταβολικά για κάθε πακέτο μαθημάτων</li>
          <li>Αποδεκτές μέθοδοι: πιστωτική/χρεωστική κάρτα, τραπεζική μεταφορά, μετρητά</li>
          <li>Για εγγραφές ανηλίκων απαιτείται η συναίνεση γονέα/κηδεμόνα</li>
          <li>Εκπτώσεις διατίθενται για πακέτα μαθημάτων και οικογενειακές εγγραφές</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>5. Ακυρώσεις και Αναβολές</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          <strong>Ακύρωση από τον μαθητή:</strong>
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px', marginBottom: '15px' }}>
          <li>Ακύρωση τουλάχιστον 24 ώρες πριν: Δωρεάν αναπρογραμματισμός</li>
          <li>Ακύρωση εντός 24 ωρών: Χρέωση 50% της αξίας του μαθήματος</li>
          <li>Μη εμφάνιση χωρίς ειδοποίηση: Χρέωση 100% της αξίας</li>
          <li>Σε περίπτωση ασθένειας με ιατρική βεβαίωση: Δωρεάν αναπρογραμματισμός</li>
        </ul>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          <strong>Ακύρωση από τη σχολή:</strong> Πλήρης επιστροφή χρημάτων ή αναπρογραμματισμός 
          κατά την επιλογή του μαθητή.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>6. Υποχρεώσεις Μαθητών</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Οι μαθητές συμφωνούν να:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Φτάνουν έγκαιρα στα μαθήματα</li>
          <li>Φέρνουν τα απαραίτητα μουσικά όργανα και υλικά</li>
          <li>Σέβονται τους καθηγητές και τους άλλους μαθητές</li>
          <li>Φροντίζουν για τον εξοπλισμό της σχολής</li>
          <li>Ακολουθούν τους κανόνες υγιεινής και ασφάλειας</li>
          <li>Μην ενοχλούν άλλα μαθήματα που διεξάγονται ταυτόχρονα</li>
          <li>Εξασκούνται τακτικά στο σπίτι όπως συνιστάται</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>7. Πνευματική Ιδιοκτησία</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Όλο το περιεχόμενο της ιστοσελίδας, συμπεριλαμβανομένων κειμένων, γραφικών, λογότυπων, 
          εικόνων, βίντεο και εκπαιδευτικού υλικού, προστατεύεται από δικαιώματα πνευματικής ιδιοκτησίας 
          και ανήκει στην Halecor ή στους παρόχους περιεχομένου. Απαγορεύεται η αναπαραγωγή, διανομή ή 
          εμπορική χρήση χωρίς γραπτή άδεια.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>8. Ευθύνη και Αποζημίωση</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Η Halecor δεν ευθύνεται για:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Τραυματισμούς που προκύπτουν από αμέλεια των μαθητών</li>
          <li>Απώλεια ή ζημιά προσωπικών αντικειμένων</li>
          <li>Ζημιά σε μουσικά όργανα που ανήκουν στους μαθητές, εκτός από περιπτώσεις αποδεδειγμένης αμέλειας του προσωπικού</li>
          <li>Διακοπή υπηρεσιών λόγω ανωτέρας βίας (φυσικές καταστροφές, πανδημίες κ.λπ.)</li>
          <li>Τεχνικά προβλήματα κατά τη διάρκεια online μαθημάτων λόγω σύνδεσης διαδικτύου</li>
        </ul>
        <p style={{ lineHeight: '1.8', color: '#333', marginTop: '15px' }}>
          Οι μαθητές συμφωνούν να αποζημιώσουν τη σχολή για οποιαδήποτε ζημιά προκαλέσουν 
          σκόπιμα ή από βαριά αμέλεια στον εξοπλισμό ή τις εγκαταστάσεις.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>9. Ιδιωτικότητα και Δεδομένα</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Η χρήση των προσωπικών σας δεδομένων διέπεται από την Πολιτική Απορρήτου μας. 
          Με την εγγραφή σας, συναινείτε στη συλλογή και επεξεργασία των δεδομένων σας όπως 
          περιγράφεται στην πολιτική αυτή. Μπορείτε να ζητήσετε πρόσβαση, διόρθωση ή διαγραφή 
          των δεδομένων σας ανά πάσα στιγμή.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>10. Φωτογραφίες και Βίντεο</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Η Halecor μπορεί να τραβήξει φωτογραφίες ή βίντεο κατά τη διάρκεια μαθημάτων, εκδηλώσεων 
          ή παραστάσεων για προωθητικούς σκοπούς. Εάν δεν επιθυμείτε να συμπεριληφθείτε σε τέτοιο 
          υλικό, παρακαλούμε ενημερώστε μας εγγράφως. Για ανηλίκους απαιτείται η συγκατάθεση των 
          γονέων/κηδεμόνων.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>11. Τροποποίηση Όρων</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Η Halecor διατηρεί το δικαίωμα να τροποποιεί αυτούς τους όρους ανά πάσα στιγμή. 
          Οι τροποποιήσεις θα δημοσιεύονται στην ιστοσελίδα μας και θα ισχύουν από τη στιγμή 
          της δημοσίευσής τους. Η συνεχιζόμενη χρήση των υπηρεσιών μας μετά από τροποποιήσεις 
          συνιστά αποδοχή των νέων όρων.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>12. Λύση Συμβολαίου</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Η Halecor διατηρεί το δικαίωμα να τερματίσει τη σύμβαση με μαθητή σε περιπτώσεις:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Επανειλημμένης μη πληρωμής</li>
          <li>Ακατάλληλης συμπεριφοράς ή παρενόχλησης</li>
          <li>Ζημιάς στον εξοπλισμό ή τις εγκαταστάσεις</li>
          <li>Παραβίασης των όρων χρήσης</li>
        </ul>
        <p style={{ lineHeight: '1.8', color: '#333', marginTop: '15px' }}>
          Σε τέτοιες περιπτώσεις, δεν θα επιστρέφονται χρήματα για ήδη πληρωμένα μαθήματα.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>13. Εφαρμοστέο Δίκαιο</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Οι παρόντες όροι διέπονται από την ελληνική νομοθεσία. Οποιαδήποτε διαφορά που 
          προκύπτει από ή σχετίζεται με αυτούς τους όρους υπόκειται στην αποκλειστική 
          δικαιοδοσία των δικαστηρίων της Αθήνας, Ελλάδα.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>14. Επικοινωνία</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Για ερωτήσεις σχετικά με τους όρους και προϋποθέσεις, επικοινωνήστε μαζί μας:
        </p>
        <p style={{ lineHeight: '1.8', color: '#333', marginTop: '10px' }}>
          <strong>Email:</strong> <a href="mailto:halecor@hotmail.com">halecor@hotmail.com</a><br />
          <strong>Τηλέφωνο:</strong> +30 210 1234567<br />
          <strong>Διεύθυνση:</strong> Οδός Μουσικής 123, Αθήνα 10678, Ελλάδα<br />
          <strong>Ώρες εξυπηρέτησης:</strong> Δευτέρα - Παρασκευή: 09:00 - 21:00, Σάββατο: 10:00 - 18:00
        </p>
      </section>

      <section style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '5px' }}>
        <p style={{ lineHeight: '1.8', color: '#666', fontSize: '14px', textAlign: 'center' }}>
          Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}<br />
          Με την εγγραφή σας στη Halecor, επιβεβαιώνετε ότι έχετε διαβάσει και κατανοήσει τους παρόντες όρους.
        </p>
      </section>
    </div>
  
    </>);
};

export default TermsConditions;